import { __, Alert, confirm } from "modules/theme";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import APIManager from "modules/common/apiManager";
import Select from "react-select-plus";
import {
  ModalForm,
  ModalFormContainer,
} from "../../../../theme/theme1/common/styles/main";
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  ControlLabel,
} from "modules/theme";
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper,
} from "modules/theme";
import { CARRIER_RATE_VALIDATION } from "../../../../common/utils/Validation/Validation";

class CarrierAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `Carrier Rate`;
    this.moduleUrl = `setting/telephony`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
    const { telephonyId } = props;
  }
  setData(editData = "") {
    editData = editData || {};
    this.state = {
      isLoading: false,
      countryCode: editData.countryCode || null,
      // currency: editData.currency || '',
      destination: editData.destination || "",
      rate: editData.rate || "",
      intialPulse: editData.intialPulse || "",
      subSequentPulse: editData.subSequentPulse || "",
      connectionCharge: editData.connectionCharge || "",
    };
  }

  resetAllData() {
    this.setState({
      countryCode: null,
      destination: "",
      rate: "",
      intialPulse: "",
      subSequentPulse: "",
      connectionCharge: "",
    });
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  handleSelect(selectedOption, name) {
    this.setState({ [name]: selectedOption ? selectedOption.value : null });
  }

  // apiResponse(errorCode, data) {
  //   if (errorCode === 201) {
  //     Alert.success(`${data.message}`);
  //     this.setData();
  //     this.props.closeModal(true);
  //   } else {
  //     if( data && data.message ){
  //       Alert.error(`${data.message}`);
  //     } else {
  //       Alert.error( "Something Wrong Happend");
  //     }
  //   }
  // }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(message);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(message);
      this.setState({ isLoading: false });
    }
  }

  saveData(e) {
    const { telephonyId } = this.props.telephonyId;
    console.log("tele", telephonyId);
    e.preventDefault();
    this.setState({ isLoading: true });
    if (this.state.rate < 0.000001 || this.state.rate > 1000) {
      this.setState({ isLoading: false });
      return Alert.error(CARRIER_RATE_VALIDATION.RATE);
    }
    if (
      this.state.connectionCharge < 0.000001 ||
      this.state.connectionCharge > 1000
    ) {
      this.setState({ isLoading: false });
      return Alert.error(CARRIER_RATE_VALIDATION.CONNECTION_CHARGE);
    }
    const re = /^[\.0-9+]*$/;
    if (!re.test(this.state.countryCode)) {
      this.setState({ isLoading: false });
      Alert.error(CARRIER_RATE_VALIDATION.COUNTRY_CODE);
    } else {
      let _this = this;
      let tData = {
        countryCode: this.state.countryCode,
        // currency: this.state.currency,
        destination: this.state.destination,
        rate: this.state.rate,
        intialPulse: this.state.intialPulse,
        subSequentPulse: this.state.subSequentPulse,
        connectionCharge: this.state.connectionCharge,
      };
      if (this.props.editData && this.props.editData._id) {
        this.mAPI.sendPostAPI(
          `${this.moduleUrl}/${telephonyId}/${this.props.editData._id}`,
          tData,
          (data) => {
            console.log(JSON.stringify(data, null, 2));
            if (data) {
              _this.setData();
              _this.props.closeModal(true);
              Alert.success(`${this.moduleName} updated successfully.`);
            }
            this.setState({ isLoading: false });
          },
          (errorCode, data) => {
            this.apiResponse(errorCode, data);
          },
          "private",
          { id: tData._id },
          "PUT"
        );
      } else {
        this.mAPI.sendPostAPI(
          `${this.moduleUrl}/${telephonyId}`,
          tData,
          (data) => {
            this.setState({ isLoading: false });
            _this.setData();
            _this.props.update();
            _this.props.closeModal(true);
            Alert.success(`${this.moduleName} created successfully.`);
          },
          (errorCode, data) => {
            console.log("errorCode", errorCode);
            this.setState({ isLoading: false });
            console.log("data", data);
            this.apiResponse(errorCode, data);
          }
        );
      }
    }
  }

  render() {
    const { modalType } = this.props;
    const exceptThisSymbols = ["e", "E", "-"];
    const valid = /^[a-zA-Z\s]+$/;
    const re = /^[\.0-9]*$/;
    console.log("State Data", this.state);
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)}>
        <ModalFormContainer>
          {/* <form onSubmit={e => this.saveData(e)}> */}
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("country Code", {
                placeholder: "Country Code",
                defaultValue: "",
                autoFocus: true,
                required: true,
                type: "number",
                id: "countryCode",
                value: this.state.countryCode,
                onKeyDown: (e) => {
                  exceptThisSymbols.includes(e.key) && e.preventDefault();
                },
                onChange: (e) => {
                  if (
                    valid.test(e.target.value) ||
                    e.target.value.length >= 10
                  ) {
                    return false;
                  }
                  console.log("");
                  this.setState({ countryCode: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          {/* <FormWrapper>
              <FormColumn>
                {this.renderFormGroup('currency', {
                  defaultValue: '',
                  autoFocus: true,
                  required: true,
                  id: 'currency',
                  value: this.state.currency,
                  onChange: e => {
                    this.setState({ currency: e.target.value });
                  }
                })}
              </FormColumn>
            </FormWrapper> */}
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("destination", {
                placeholder: "Destination",
                defaultValue: "",
                autoFocus: false,
                required: true,
                maxLength: 100,
                id: "destination",
                value: this.state.destination,
                onChange: (e) => {
                  if (e.target.value === " " || e.target.value.length >= 1000) {
                    return false;
                  }
                  this.setState({ destination: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("rate", {
                placeholder: "Rate",
                defaultValue: "",
                autoFocus: false,
                required: true,
                id: "rate",
                // max: 1000000,
                // min: 0,
                // maxLength: 3,
                value: this.state.rate,
                onKeyDown: (e) => {
                  exceptThisSymbols.includes(e.key) && e.preventDefault();
                },
                onChange: (e) => {
                  if (
                    !re.test(e.target.value) ||
                    e.target.value < 0 ||
                    e.target.value > 1000
                  ) {
                    return false;
                  }
                  this.setState({ rate: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Initial Pulse", {
                placeholder: "Initial Pulse",
                defaultValue: "",
                autoFocus: false,
                required: true,
                id: "intialPulse",
                max: 1000000,
                // min: 0,
                value: this.state.intialPulse,
                onKeyDown: (e) => {
                  exceptThisSymbols.includes(e.key) && e.preventDefault();
                },
                onChange: (e) => {
                  if (
                    !re.test(e.target.value) ||
                    e.target.value < 0 ||
                    e.target.value > 300
                  ) {
                    return false;
                  }
                  this.setState({ intialPulse: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Subsequent Pulse", {
                placeholder: "Subsequent Pulse",
                defaultValue: "",
                autoFocus: false,
                required: true,
                id: "subSequentPulse",
                max: 1000000,
                // min: 0,
                value: this.state.subSequentPulse,
                onKeyDown: (e) => {
                  exceptThisSymbols.includes(e.key) && e.preventDefault();
                },
                onChange: (e) => {
                  if (
                    !re.test(e.target.value) ||
                    e.target.value < 0 ||
                    e.target.value > 300
                  ) {
                    return false;
                  }
                  this.setState({ subSequentPulse: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Connection Charge", {
                placeholder: "Connection Charge",
                defaultValue: "",
                autoFocus: false,
                required: true,
                id: "connectionCharge",
                max: 100,
                min: 0,
                maxLength: 3,
                value: this.state.connectionCharge,
                onKeyDown: (e) => {
                  exceptThisSymbols.includes(e.key) && e.preventDefault();
                },
                onChange: (e) => {
                  if (
                    !re.test(e.target.value) ||
                    e.target.value < 0 ||
                    e.target.value > 100
                  ) {
                    return false;
                  }
                  this.setState({ connectionCharge: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          {/*   </form> */}
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <Button
            className="grey-btn"
            btnStyle="cancel"
            onClick={() => this.props.closeModal()}
            size="xl"
          >
            Cancel
          </Button>
          <Button
            className="blue-btn"
            type="submit"
            btnStyle="default"
            isLoading={this.state.isLoading}
            disabled={this.state.isLoading}
            size="xl"
            style={{ float: "right" }}
          >
            {this.props.editData && this.props.editData._id ? "Update" : "Add"}
          </Button>
        </ModalFooter>
      </ModalForm>
    );
  }
}

CarrierAddEdit.propTypes = {
  group: PropTypes.array,
};

CarrierAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired,
};

export default CarrierAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/CarrierRate/components/CarrierRateAddEdit.js